<template>
  <div class="content list-list list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">AM Contract Summary</h4>
          <!-- Start search part -->
          <div class="row">
            <div class="col-sm-3">
              <base-input label="Signed Date" class="range-picker">
                <el-date-picker
                  type="datetimerange"
                  placeholder="Signed Date"
                  v-model="searchKeyContract.SignedDateList"
                  class="form-control"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  format="DD/MM/YYYY HH:mm:ss"
                >
                </el-date-picker>
              </base-input>
            </div>

            <div class="col-sm-9">
              <div class="row">
                <div style="width: 100%">
                  <div
                    style="
                      column-gap: 5px;
                      text-align: right;
                      margin-right: 15px;
                      margin-top: 20px;
                    "
                  >
                    <base-button type="primary" @click="search"
                      >Search</base-button
                    >
                    <base-button type="primary" @click="reset"
                      >Reset</base-button
                    >
                    <base-button type="primary" @click="exportExcel"
                      >Export Excel</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end Search part-->

          <el-tabs type="border-card" @tab-click="TabClick">
            <!-- ContractList -->
            <el-tab-pane label="ContractList">
              <el-row>
                <el-col :span="24">
                  <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12" style="display: flex">
                      <span
                        style="
                          margin-left: auto;
                          line-height: 32px;
                          padding-right: 20px;
                        "
                      >
                        Total No. of Record: {{ searchKeyContract.total }}
                        <base-pagination
                          class="pagination-no-border"
                          v-model="searchKeyContract.pageIndex"
                          :total="searchKeyContract.total"
                          :pagesToDisplay="10"
                          style="float: right"
                          :value="searchKeyContract.pageIndex"
                          @changePage="ChangePageSearchContract"
                          @nextPage="ChangePageSearchContract"
                        >
                        </base-pagination>
                      </span>
                    </div>
                  </div>

                  <el-table
                    :data="list"
                    style="width: 100%"
                    border
                    header-row-class-name="header-row"
                    @filter-change="filterChange"
                    class="report"
                    table-layout="auto"
                  >
                    <el-table-column
                      prop="contract_serial_no"
                      label="contract_serial_no"
                      width="150"
                    />

                    <tablecolumnClick2
                      prop="contract_no"
                      linkTo="ContractList"
                      label="Contract_number"
                      :width="150"
                    />
                    <tablecolumn
                      prop="contracting_party"
                      label="ContractingParty"
                      :width="300"
                    />
                    <tablecolumn
                      prop="direct_client"
                      label="Directclient(Y/N)?"
                      width="150"
                    />
                    <tablecolumn
                      prop="advertiser"
                      label="Advertiser"
                      :width="300"
                    />
                    <tablecolumn prop="product" label="Product" :width="150" />
                    <tablecolumn
                      prop="subgroup_code"
                      label="subgroup_code"
                      :width="150"
                    />
                    <tablecolumn
                      prop="sitecode"
                      label="site_code"
                      :width="150"
                    />
                    <tablecolumn
                      prop="salesman"
                      label="Salesman"
                      :width="150"
                    />
                    <tablecolumn
                      prop="teamhead"
                      label="TeamHead"
                      :width="150"
                    />
                    <el-table-column
                      prop="additionalCommissionRate1"
                      label="additionalcommissionrate1"
                      :width="190"
                    />
                    <el-table-column
                      prop="additionalCommissionRate2"
                      label="additionalcommissionrate2"
                      :width="190"
                    />
                    <el-table-column
                      prop="first_commencement_date"
                      label="EarliestCommencingDate(excludingbonus)"
                      :formatter="formatterCellDate"
                      width="200"
                    />
                    <el-table-column
                      prop="final_completion_date"
                      label="finalCompletionDate(excludingbonus)"
                      :formatter="formatterCellDate"
                      width="200"
                    />
                    <tablecolumn prop="currency" label="currency" width="150" />
                    <el-table-column
                      prop="contract_sum"
                      label="ContractSum"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="contract_sum_hkd"
                      label="ContractSum_hkd"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="with_bonus_offer"
                      label="with_bonus_offer(y/n)?"
                      :width="150"
                    />
                    <el-table-column
                      prop="unused"
                      label="unused(y/n)?"
                      :width="100"
                    />
                    <el-table-column
                      prop="voids"
                      label="void(y/n)?"
                      :width="100"
                    />
                    <el-table-column
                      prop="cancelled"
                      label="cancelled(y/n)?"
                      :width="180"
                    />
                    <el-table-column
                      prop="received_signed"
                      label="ReceivedSignedContract(Y/N)?"
                      :formatter="formatterCellDateTime"
                      :width="190"
                    />
                    <el-table-column
                      prop="invalid_contract"
                      label="invalidcontract(y/n)?"
                      :width="180"
                    />
                    <el-table-column
                      prop="contract_status"
                      label="Contractstatus"
                      :width="180"
                    />
                    <el-table-column
                      prop="remarks"
                      label="Remarks"
                      :width="80"
                    />
                    <el-table-column
                      prop=""
                      label="Renewal_Or_Not"
                      :width="120"
                    />
                    <el-table-column
                      prop="reffrom"
                      label="Ref from (GPP contract_serial_no)"
                      :width="240"
                    />
                    <el-table-column
                      prop="updateByIris_Shirley"
                      label="Update By"
                      :width="150"
                    />
                    <el-table-column
                      prop="contractSumforcommission"
                      label="Contract Amount for Commission purpose"
                      :formatter="formatterCellMoney"
                      :width="260"
                    />
                    <el-table-column
                      prop="redsquotation"
                      label="Red's quotation"
                      :width="180"
                    />
                    <el-table-column
                      prop="cat_Code"
                      label="Cat_Code"
                      :width="80"
                    />
                    <el-table-column
                      prop=""
                      label="validcontractsum"
                      :width="120"
                    />
                    <el-table-column
                      prop=""
                      label="validinvoicesum"
                      :width="120"
                    />
                    <el-table-column prop="" label="AB-AA" :width="80" />
                    <el-table-column prop="" label="fromitemlist" :width="80" />
                    <el-table-column prop="" label="diff" :width="80" />
                    <el-table-column
                      prop=""
                      label="contract no from itemlist"
                      :width="150"
                    />
                    <el-table-column prop="" label="same or not" :width="80" />
                    <el-table-column
                      prop="asst_sales_director"
                      label="Assist_Sales_Director"
                      :width="180"
                    />
                    <el-table-column
                      prop=""
                      label=" valid production contract"
                      :width="150"
                    />
                    <tablecolumn
                      prop="project_m_p"
                      label="project/media(p/m)?"
                      :width="180"
                    />
                    <el-table-column prop="bR" label="BR (Y/N)" :width="80" />
                    <el-table-column prop="" label="Pool Head" :width="80" />
                    <el-table-column
                      prop=""
                      label="check contract serial no is duplicated or not (Y / N)"
                      :width="160"
                    />
                    <el-table-column
                      prop=""
                      label="checking length"
                      :width="100"
                    />

                    <el-table-column
                      prop="isNewClient"
                      label="New Client"
                      :width="80"
                    />
                    <el-table-column
                      prop="signedDate"
                      label="Signed Date"
                      :formatter="formatterCellDateTime"
                      width="130"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </el-tab-pane>

            <!-- ItemList -->
            <el-tab-pane label="ItemList">
              <el-row>
                <el-col :span="24">
                  <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12" style="display: flex">
                      <span
                        style="
                          margin-left: auto;
                          line-height: 32px;
                          padding-right: 20px;
                        "
                      >
                        Total No. of Record: {{ searchKeyItem.total }}
                        <base-pagination
                          class="pagination-no-border"
                          v-model="searchKeyItem.pageIndex"
                          :total="searchKeyItem.total"
                          :pagesToDisplay="10"
                          style="float: right"
                          :value="searchKeyItem.pageIndex"
                          @changePage="ChangePageSearchItem"
                          @nextPage="ChangePageSearchItem"
                        >
                        </base-pagination>
                      </span>
                    </div>
                  </div>
                  <el-table
                    :data="itemList"
                    style="width: 100%"
                    border
                    header-row-class-name="header-row"
                    @filter-change="filterChange"
                    class="report"
                    table-layout="auto"
                  >
                    <el-table-column
                      prop="item_serial_no"
                      label="item serial number"
                      :width="150"
                    />
                    <el-table-column
                      prop="contract_serial_no"
                      label="Contract serial No"
                      :width="150"
                    />
                    <tablecolumnClick2
                      prop="old_contract_no"
                      linkTo="ItemList"
                      label="Contractnumber"
                      :width="150"
                    />
                    <el-table-column
                      prop="subgroup"
                      label="Sub-GroupCode"
                      :width="120"
                    />
                    <el-table-column
                      prop="site_code"
                      label="SiteAbbreviation"
                      :width="120"
                    />

                    <el-table-column
                      prop="location_panel_no"
                      label="Description of Location"
                      :width="300"
                    />
                    <el-table-column
                      prop="typePanel"
                      label="Type/Panel"
                      :width="300"
                    />

                    <el-table-column
                      prop="nothing1"
                      label="Nothing1"
                      :width="100"
                    />
                    <el-table-column
                      prop="nothing2"
                      label="Nothing2"
                      :width="100"
                    />
                    <el-table-column
                      prop="nothing3"
                      label="Nothing3"
                      :width="100"
                    />
                    <tablecolumn
                      prop="bonus_item"
                      label="Bonus (Y/N)"
                      :width="150"
                    />
                    <el-table-column
                      prop="commencement_date"
                      label="Commencing Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column
                      prop="completion_date"
                      label="Completion Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <tablecolumn
                      prop="currency"
                      label="Currency"
                      :width="100"
                    />

                    <tablecolumn
                      prop="contract_sum"
                      label="item_amount"
                      :formatter="formatterCellMoney"
                      :width="130"
                    />
                    <tablecolumn
                      prop="contract_sum_hkd"
                      label="item_amount_hkd"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="gross_amount"
                      label="item_gross_rate_hkd"
                      :width="100"
                    />
                    <el-table-column
                      prop="item_gross_rate_hkd_per_booking_form"
                      label="item_gross_rate_hkd_per_booking_form"
                      :formatter="formatterCellMoney"
                      :width="280"
                    />
                    <el-table-column
                      prop="invalid_contract"
                      label="invalid_contract_or_not?"
                      :width="120"
                    />
                    <tablecolumn prop="remarks" label="Remarks" :width="100" />
                    <el-table-column
                      prop="contract_sum_for_commission"
                      label="Contract Amount for Commission Purpose"
                      :formatter="formatterCellMoney"
                      :width="245"
                    />
                    <el-table-column
                      prop="update_By_Iris_Shirley"
                      label="Updated by Iris/Sng"
                      :width="150"
                    />
                    <el-table-column
                      prop="red_s_quotation"
                      label="Red' s quotation"
                      :width="150"
                    />
                    <el-table-column
                      prop=""
                      label="contractsum_from_contractlist"
                      :width="150"
                    />
                    <el-table-column
                      prop=""
                      label="contractsum_from_itemlist"
                      :width="150"
                    />
                    <el-table-column prop="" label="diff" :width="80" />
                    <el-table-column
                      prop="sitecode_from_Contractlist"
                      label="Site code from contract list"
                      :width="200"
                    />
                    <el-table-column
                      prop="n_if_diff"
                      label='if diff, "N"'
                      :width="100"
                    />
                    <el-table-column
                      prop="gross_media_toal_exclud_loading_bonus"
                      label="Gross media toal (exclud loading & bonus)"
                      :formatter="formatterCellMoney"
                      :width="280"
                    />
                    <el-table-column
                      prop="gross_media_toal_loading"
                      label="Gross media toal (loading)"
                      :formatter="formatterCellMoney"
                      :width="240"
                    />
                    <el-table-column
                      prop="gross_media_toal_loading_bonus"
                      label="Gross media toal (loading & bonus)"
                      :formatter="formatterCellMoney"
                      :width="240"
                    />
                    <el-table-column
                      prop="log_commencement_date"
                      label="Log commencement_date"
                      :formatter="formatterCellDate"
                      :width="180"
                    />
                    <el-table-column
                      prop="log_completion_date"
                      label="Log completion_date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column
                      prop=""
                      label="checking length"
                      :width="100"
                    />

                    <el-table-column
                      prop="signedDate"
                      label="Signed Date"
                      :formatter="formatterCellDateTime"
                      width="130"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </el-tab-pane>

            <!-- PaymentInvoiceList -->
            <el-tab-pane label="PaymentInvoiceList">
              <el-row>
                <el-col :span="24">
                  <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12" style="display: flex">
                      <span
                        style="
                          margin-left: auto;
                          line-height: 32px;
                          padding-right: 20px;
                        "
                      >
                        Total No. of Record: {{ searchKeyPaymentInvoice.total }}
                        <base-pagination
                          class="pagination-no-border"
                          v-model="searchKeyPaymentInvoice.pageIndex"
                          :total="searchKeyPaymentInvoice.total"
                          :pagesToDisplay="10"
                          style="float: right"
                          :value="searchKeyPaymentInvoice.pageIndex"
                          @changePage="ChangePageSearchPaymentInvoice"
                          @nextPage="ChangePageSearchPaymentInvoice"
                        >
                        </base-pagination>
                      </span>
                    </div>
                  </div>
                  <el-table
                    :data="paymentInvoiceList"
                    style="width: 100%"
                    border
                    header-row-class-name="header-row"
                    @filter-change="filterChange"
                    class="report"
                    table-layout="auto"
                  >
                    <el-table-column
                      prop="payment_serial_no"
                      label="Payment_serial_no"
                      :width="150"
                    />
                    <el-table-column
                      prop="contract_serial_no"
                      label="Contract_serial_No"
                      :width="150"
                    />
                    <tablecolumnClick2
                      prop="contract_no"
                      linkTo="ContractList"
                      label="Contractnumber"
                      :width="150"
                    />
                    <el-table-column
                      prop="invalid_payment_serial_no"
                      label="invalid_payment_serial_no"
                      :width="170"
                    />
                    <el-table-column
                      prop="payment_details"
                      label="Payment Details"
                      :width="150"
                    />
                    <el-table-column
                      prop="invoice_serial_no"
                      label="Invoice_serial_no"
                      :width="150"
                    />
                    <tablecolumnClick2
                      prop="invoice_Number"
                      linkTo="invoice"
                      label="Invoice Number"
                      :width="150"
                    />
                    <el-table-column
                      prop="invoice_cancelled"
                      label="invoice_cancelled(y/n)?"
                      :width="160"
                    />
                    <el-table-column
                      prop="invoice_date"
                      label="Invoice Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column
                      prop="due_date"
                      label="Due Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column
                      prop="currency"
                      label="Currency"
                      :width="150"
                    />
                    <el-table-column
                      prop="invoice_amount"
                      label="Invoice Amount"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="calculated_invoice_sum_hkd"
                      label="Invoice Amount_hkd"
                      :formatter="formatterCellMoney"
                      :width="180"
                    />
                    <el-table-column
                      prop="receipt_date"
                      label="Receipt Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column prop="bank" label="bank" :width="350" />
                    <el-table-column
                      prop="cheque"
                      label="cheque"
                      :width="150"
                    />
                    <el-table-column
                      prop="amount_hkd"
                      label="AmountHK$"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="remarks"
                      label="Remarks"
                      :width="150"
                    />
                    <!-- <el-table-column prop="exchangediff" label="Exchangediff" :width="150" /> -->
                    <el-table-column
                      prop="remark2"
                      label="Remark2 & Enrty Date"
                      :formatter="formatterCellDate"
                      :width="150"
                    />
                    <el-table-column
                      prop="update_By_Iris_Shirley"
                      label="Update by Iris/Sng"
                      :width="150"
                    />
                    <el-table-column
                      prop="receipt_amt_Invoice_amt"
                      label="Receipt amt = Invoice amt"
                      :width="180"
                    />
                    <el-table-column
                      prop="check_currency"
                      label="check currency"
                      :width="150"
                    />
                    <el-table-column prop="" label="Temp2" :width="80" />
                    <el-table-column prop="" label="Temp3" :width="80" />
                    <el-table-column
                      prop="sum_if_Invoice_Sum"
                      label="Sum_if Invoice Sum"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="contract_Sum_for_commission"
                      label="Contract Sum for commission (HK$)"
                      :formatter="formatterCellMoney"
                      :width="250"
                    />
                    <el-table-column prop="factor" label="Factor" :width="80" />
                    <el-table-column
                      prop="rcvd_amt_factor"
                      label="Rcvd amt * factor"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="valid_Invoiced_sum"
                      label="Valid Invoiced sum"
                      :formatter="formatterCellMoney"
                      :width="150"
                    />
                    <el-table-column
                      prop="checking_length_Remark"
                      label="checking length Remark"
                      :width="150"
                    />
                    <el-table-column
                      prop="checking_length_Remark2"
                      label="checking length Remark2"
                      :width="160"
                    />
                    <el-table-column
                      prop="contractingparty"
                      label="Contracting party"
                      :width="350"
                    />
                    <el-table-column
                      prop=""
                      label="Overdue Check"
                      :width="150"
                    />
                    <el-table-column
                      prop="voidSettlement"
                      label="Void Settlement"
                      :width="160"
                    />
                    <el-table-column
                      prop="voidDate"
                      label="Void Date"
                      :formatter="formatterCellDate"
                      :width="160"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import './css/index.css';
import { ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import PubSub from 'pubsub-js';
import router from '@/router';
import { useAuthorityStore } from '@/store/authority';
import { ElMessageBox } from 'element-plus';
// api
import reportapi from '@/network/report';
// components
import tablecolumn from '@/components/tablecolumn';
import tablecolumnClick2 from '@/components/tablecolumnClick2';
import dateJs from '@/assets/js/date.js';

import { useContractStore } from '@/store/contract';
const useContract = useContractStore();
// tool
import {
  formatterCellDate,
  formatterCellMoney,
  formatterCellDateTime,
} from '@/assets/js/formatter';
//变更分页
const ChangePageSearchContract = async (data) => {
  searchKeyContract.pageIndex = data;
  search();
};
//变更分页
const ChangePageSearchItem = async (data) => {
  searchKeyItem.pageIndex = data;
  search();
};
//变更分页
const ChangePageSearchPaymentInvoice = async (data) => {
  searchKeyPaymentInvoice.pageIndex = data;
  search();
};

//搜索条件实体
const searchKeyContract = reactive({
  pageIndex: 1,
  pageSize: 10,
  SignedDateList: [
    `${dateJs.ConvertDate(dateJs.AddDays(new Date(), -7))}${' 00:00:00'}`,
    `${dateJs.ConvertDate(new Date())}${' 23:59:59'}`,
  ],
});
const searchKeyItem = reactive({
  pageIndex: 1,
  pageSize: 10,
});
const searchKeyPaymentInvoice = reactive({
  pageIndex: 1,
  pageSize: 10,
});
const tabkey = ref('ContractList');
// #region datas
const list = ref([]);
const itemList = ref([]);
const paymentInvoiceList = ref([]);
// #endregion

onBeforeMount(async () => {
  //判断是否有权限查看,没有权限跳转主页
  await IsAuthority();
  await search();
});
//判断是否有权限查看,没有权限跳转主页
const IsAuthority = async () => {
  if (!useAuthorityStore().GetAuthority('Menu_Finance_read')) {
    await ElMessageBox.alert('No permission.', 'Message', {
      confirmButtonText: 'OK',
    })
      .then(() => {
        //跳转主页
        router.push({
          name: 'report',
        });
      })
      .catch(() => {
        //跳转主页
        router.push({
          name: 'report',
        });
      });
  }
};
//切换tab
const TabClick = (data) => {
  tabkey.value = data.props.label;
  console.log(data.props.label);
};
// event: 搜索
const search = async () => {
  var search = {
    contractSearch: searchKeyContract,
    itemSearch: searchKeyItem,
    paymentInvoiceSearch: searchKeyPaymentInvoice,
  };
  const search_res = await reportapi
    .GetAMContractSummaryList(search)
    .then((res) => res);
  console.log(222, search_res);
  //总数
  searchKeyContract.total = search_res.data.contractList.total;
  //数据列表
  list.value = search_res.data.contractList.list;

  //itemList
  searchKeyItem.total = search_res.data.itemList.total;
  itemList.value = search_res.data.itemList.list;

  //PaymentInvoiceList
  searchKeyPaymentInvoice.total = search_res.data.paymentInvoiceList.total;
  paymentInvoiceList.value = search_res.data.paymentInvoiceList.list;
};
//导出数据到excel
const exportExcel = async () => {
  var search = {
    contractSearch: searchKeyContract,
    itemSearch: searchKeyItem,
    paymentInvoiceSearch: searchKeyPaymentInvoice,
    isToExcel: true,
  };
  const result = await reportapi
    .GetAMContractSummaryList(search)
    .then((res) => res);
  //if (result.statusText === 'OK') {
  if (result.status === 200) {
    window.open(
      result.data.replace(
        'http://18.166.57.80:3012',
        'https://bb-matrix-api.asiaray.com'
      ),
      '_self'
    );
  }
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKeyContract).map((key) => {
    delete searchKeyContract[key];
  });
  searchKeyContract.pageIndex = 1;
  searchKeyContract.pageSize = 10;

  Object.keys(searchKeyItem).map((key) => {
    delete searchKeyItem[key];
  });
  searchKeyItem.pageIndex = 1;
  searchKeyItem.pageSize = 10;

  Object.keys(searchKeyPaymentInvoice).map((key) => {
    delete searchKeyPaymentInvoice[key];
  });
  searchKeyPaymentInvoice.pageIndex = 1;
  searchKeyPaymentInvoice.pageSize = 10;

  search();
};
const filterChange = async (filters) => {
  console.log('filtersfilters', filters);
  if (filters.postTimeTypes) {
    searchKeyContract.postTimeTypes = filters.postTimeTypes;
  }
  if (filters.depostTimeTypes) {
    searchKeyContract.depostTimeTypes = filters.depostTimeTypes;
  }
  await search();
};
//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    if (tabkey.value == 'ContractList') {
      // 动态赋值
      searchKeyContract[`${data.key}`] = data.value;
    }
    if (tabkey.value == 'ItemList') {
      // 动态赋值
      searchKeyItem[`${data.key}`] = data.value;
    }

    if (tabkey.value == 'PaymentInvoiceList') {
      // 动态赋值
      searchKeyPaymentInvoice[`${data.key}`] = data.value;
    }
    search();
  });

  PubSub.subscribe('modeclick2', (name, data) => {
    if (data.linkTo === 'ContractList') {
      useContract.activeName = 'DraftContract';
      window.open('contract?ContractNo=' + data.data.contract_no + '&cId=' + data.data.contract_Id);
      // router.push({
      //   name: 'contract',
      //   query: {
      //     ContractNo: data.data.contract_no,
      //     cId: data.data.contract_Id,
      //   },
      // });
    } else if (data.linkTo === 'ItemList') {
      useContract.activeName = 'DraftContract';
      window.open('contract?ContractNo=' + data.data.old_contract_no + '&cId=' + data.data.contract_Id);
      // router.push({
      //   name: 'contract',
      //   query: {
      //     ContractNo: data.data.old_contract_no,
      //     cId: data.data.contract_Id,
      //   },
      // });
    } else if (data.linkTo === 'invoice') {
      window.open(data.data.linkToInvoice, '_blank');
    }
  });
});
</script>

<style scoped>
.list {
  font-size: 13px;
}

.content.list-list .form-group.has-label .el-input__inner {
  position: relative;
  top: 5px;
}
</style>
